import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { money } from "@/components/reports/reportUtils";

export function ReporteClientes({ data }) {
  const items = data?.items || [];
  const t = data?.totales;
  return (
    <Table data-testid="reporte-clientes-table">
      <TableHeader>
        <TableRow>
          <TableHead>Cliente</TableHead><TableHead className="text-right">Loads</TableHead>
          <TableHead className="text-right">Facturación</TableHead><TableHead className="text-right">Costos</TableHead>
          <TableHead className="text-right">Ganancia</TableHead><TableHead className="text-right">Margen Prom.</TableHead>
          <TableHead className="text-right">Pendiente Cobro</TableHead><TableHead className="text-right">Días Prom. Cobro</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {items.map((r) => (
          <TableRow key={r.client_id} data-testid={`reporte-clientes-row-${r.client_id}`}>
            <TableCell>{r.client_nombre}</TableCell>
            <TableCell className="text-right">{r.cantidad_loads}</TableCell>
            <TableCell className="text-right">{money(r.facturacion_usd)}</TableCell>
            <TableCell className="text-right">{money(r.costos_usd)}</TableCell>
            <TableCell className="text-right">{money(r.ganancia_usd)}</TableCell>
            <TableCell className="text-right">{r.margen_promedio_ponderado_pct}%</TableCell>
            <TableCell className="text-right">{money(r.pendiente_cobro_usd)}</TableCell>
            <TableCell className="text-right">{r.dias_promedio_cobro_real ?? "—"}</TableCell>
          </TableRow>
        ))}
        {items.length === 0 && (
          <TableRow><TableCell colSpan={8} className="text-center text-sm text-muted-foreground py-8">Sin resultados para los filtros aplicados.</TableCell></TableRow>
        )}
        {t && items.length > 0 && (
          <TableRow className="bg-slate-50 font-semibold" data-testid="reporte-clientes-totales">
            <TableCell>TOTAL</TableCell><TableCell className="text-right">{t.cantidad_loads}</TableCell>
            <TableCell className="text-right">{money(t.facturacion_usd)}</TableCell>
            <TableCell className="text-right">{money(t.costos_usd)}</TableCell>
            <TableCell className="text-right">{money(t.ganancia_usd)}</TableCell>
            <TableCell className="text-right">{t.margen_promedio_ponderado_pct}%</TableCell>
            <TableCell className="text-right">{money(t.pendiente_cobro_usd)}</TableCell><TableCell />
          </TableRow>
        )}
      </TableBody>
    </Table>
  );
}
